import type { Service } from '@/types/booking';

import type { ServiceGroup } from './getServiceGroups';

interface GetUngroupedServicesParams {
  services: Service[];
  groups: ServiceGroup[];
}

/**
 * The `services` that no group lists, in their own order. The grouped flat
 * list shows them after the groups so a service without a visible L2 is not
 * dropped.
 */
export function getUngroupedServices({
  services,
  groups,
}: GetUngroupedServicesParams): Service[] {
  const groupedIds = new Set(
    groups.flatMap(({ services: inGroup }) => inGroup.map(({ id }) => id)),
  );

  return services.filter(({ id }) => !groupedIds.has(id));
}
